import React from "react";
import { Component } from "react";
import IdentifyProof from "views/profile/components/documents/components/IdentifyProof";
import AddressProof from "views/profile/components/documents/components/AddressProof";
import Employmentproof from "views/profile/components/documents/components/Employmentproof";
import EducationProof from "views/profile/components/documents/components/EducationProof";
import {
  getDocsAction,
} from "store/Profile";
import { connect } from "react-redux";
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  componentDidMount() {
    this.props.getDocs(this.props.Auth.HCID);
  }
  render() {
    return (
      <div class="py-6">
        <ul class="list-reset flex  custom-tabs-r px-4">
          <li
            className={
              this.state.isTabOpenNo == 1
                ? "font-bold text-black  active tab-submenu-active "
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 1 })}
          >
            <p className="tab-submenu px-4 fsize14">Identify proof</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 2
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 2 })}
          >
            <p className="tab-submenu px-4 fsize14">Address proof</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 3
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 3 })}
          >
            <p className="tab-submenu px-4 fsize14">Employment proof</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 4
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 4 })}
          >
            <p className="tab-submenu px-4 fsize14">Education proof</p>
          </li>
        </ul>
        <div className={this.state.isTabOpenNo == 1 ? " active" : "hidden"}>
          <IdentifyProof />
        </div>
        <div className={this.state.isTabOpenNo == 2 ? " active" : "hidden"}>
          <AddressProof />
        </div>

        <div className={this.state.isTabOpenNo == 3 ? " active" : "hidden"}>
          <Employmentproof />
        </div>
        <div className={this.state.isTabOpenNo == 4 ? " active" : "hidden"}>
          <EducationProof />
        </div>
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Documents: state.Profile.home.DOCUMENTS,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDocs: async (payload) => await dispatch(getDocsAction(payload)),
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
